import { Box, CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import { AppBar, AppFooter } from './components';
import OrgsProvider, { injectLoginUrl } from './hooks/useOrgs';
import AuthProvider from './hooks/useToken';
import { Router } from './Router';
import theme from './utils/theme';

function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    injectLoginUrl(window.location.href);
    setReady(true);
  }, []);

  // Add message listener for multi-domain token clearing
  // This listens for logout messages from other domains and clears local tokens
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      // Define trusted domains that can send logout messages
      const trustedDomains = [
        'https://dev.pubs.komodohealth.com',
        'https://test.pubs.komodohealth.com',
        'https://current.test.pubs.komodohealth.com',
        'https://previous.test.pubs.komodohealth.com',
        'https://deprecated.test.pubs.komodohealth.com',
      ];

      // Check if the message is from a trusted domain and is a clear tokens message
      if (trustedDomains.includes(event.origin) && event.data?.type === 'CLEAR_TOKENS') {
        // Clear all authentication tokens from localStorage
        localStorage.removeItem('token');
        localStorage.removeItem('instanceUrl');
        localStorage.removeItem('APIVersion');

        // Force a page reload to clear React context and ensure user is logged out
        window.location.reload();
      }
    };

    // Add the event listener
    window.addEventListener('message', handleMessage);

    // Clean up the event listener when component unmounts
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  if (!ready) return <></>;

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <SnackbarProvider maxSnack={3}>
            <OrgsProvider>
              <BrowserRouter>
                <CssBaseline />
                <Box display={'flex'} minHeight={'100vh'} flexDirection={'column'} justifyContent={'space-between'}>
                  <Box>
                    <AppBar />
                    <Box>
                      <Box margin="auto" maxWidth="1140px" p={3} pt={9} overflow="none">
                        <Router />
                      </Box>
                    </Box>
                  </Box>
                  <AppFooter />
                </Box>
              </BrowserRouter>
            </OrgsProvider>
          </SnackbarProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
